$(document).ready(function() {

  var imgUploaderInput = $('.js-img-uploader-input');
  var imgUploaderBtn = $('.js-img-uploader-btn');
  var imgUploaderName = $('.js-img-uploader-name');


  imgUploaderBtn.on('click', function (e) {
    e.preventDefault();
    imgUploaderInput.click();
  });

  imgUploaderInput.on('change', function () {
    var image = this.files[0];
    var imageName = image.name;
    // Update name
    imgUploaderName.text(imageName);
  });

});
